import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, euro } from "@/lib/api";
import { Navigation, Phone } from "lucide-react";

export default function Tournees() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/tournees").then(({ data }) => setData(data)); }, []);

  return (
    <div>
      <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
        <h1 className="font-serif text-3xl font-bold text-brand-green">Livraisons à organiser</h1>
      </div>
      {data && (
        <>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mb-6">
            <div className="bg-white rounded-xl border border-brand-green/10 p-4"><div className="text-sm text-brand-green/60">Livraisons actives</div><div className="num text-2xl text-brand-green">{data.count}</div></div>
            <div className="bg-white rounded-xl border border-brand-green/10 p-4"><div className="text-sm text-brand-green/60">Valeur totale</div><div className="num text-2xl text-brand-green">{euro(data.total)}</div></div>
          </div>
          {Object.keys(data.zones).length === 0 && <p className="text-brand-green/50">Aucune livraison à organiser.</p>}
          {Object.entries(data.zones).map(([zone, stops]) => (
            <div key={zone} className="mb-6">
              <h2 className="font-serif text-xl font-bold text-brand-green mb-3">{zone}</h2>
              <div className="space-y-3">
                {stops.map((st) => (
                  <div key={st.id} className="bg-white rounded-xl border border-brand-green/10 p-4 flex items-center justify-between gap-4 flex-wrap" data-testid={`stop-${st.ref}`}>
                    <div>
                      <div className="font-semibold text-brand-green"><Link to={`/admin/commandes/${st.id}`} className="underline">{st.ref}</Link> — {st.customer?.name}</div>
                      <div className="text-sm text-brand-green/60">{st.delivery?.address}</div>
                      <div className="text-sm text-brand-green/60">{st.items?.map((i) => `${i.quantity}× ${i.name}`).join(", ")}</div>
                      {st.note && <div className="text-xs text-brand-gold mt-1">Note : {st.note}</div>}
                    </div>
                    <div className="flex items-center gap-3">
                      <div className="text-right"><div className="text-xs text-brand-green/50">À régler</div><div className="num text-2xl text-brand-green">{euro(st.amount)}</div></div>
                      <a href={`https://www.google.com/maps/search/${encodeURIComponent(st.delivery?.address || "")}`} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-brand-green text-white flex items-center justify-center"><Navigation className="w-4 h-4" /></a>
                      <a href={`tel:${(st.customer?.phone || "").replace(/\s/g, "")}`} className="w-10 h-10 rounded-full bg-brand-sage text-brand-green flex items-center justify-center"><Phone className="w-4 h-4" /></a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
}
